import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import DataProvider from "./contexts/DataContext";
import { toast, ToastContainer } from "react-toastify";
import { useEffect, useState, useRef } from "react";


function App() {

	return (
		<Router>
			<DataProvider>
				<AppRoutes />
				<ToastContainer />
			</DataProvider>
		</Router>
	);
}

export default App;
